@if (!addNewRoleGroup) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="navigateBack()"
          tabindex="0"
          (keydown.enter)="navigateBack()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="ngOnInit()"
          tabindex="0"
          (keydown.enter)="ngOnInit()"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Group Management</span>
      </div>
      <!-- Redirect Button -->
      <div class="button-group">
        <button
          class="primary-button"
          type="button"
          (click)="addNewRoleGroupFunc()"
        >
          Add Group <mat-icon class="btn-icon">open_in_new</mat-icon>
        </button>
      </div>
    </div>

    <div class="component-container">
      <!-- List Section -->
      <form [formGroup]="roleGroupForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">Group List</h6>
          <div class="component-actions">
            <app-common-search
              [initialSearchValue]="
                roleGroupForm?.get('roleGroupListSearch')?.value
              "
              matTooltip="Group Name"
              (searchSubmit)="onSearch($event)"
            ></app-common-search>
          </div>
        </div>
      </form>
      <!-- Separator between Header and Body -->
      <div class="component-separator"></div>

      <!-- Component Body Section -->
      <div class="component-body">
        <table>
          <thead>
            <tr>
              <th>Group Name</th>
              <th>Created At</th>
              <th>Action</th>
            </tr>
          </thead>
          @if (listOfRole.length !== 0) {
            <tbody>
              @for (
                item of listOfRole
                  | paginate
                    : {
                        id: 'rolePagination',
                        itemsPerPage: size,
                        currentPage: page,
                        totalItems: totalLength,
                      };
                track item
              ) {
                <tr>
                  <td>{{ item.groupName }}</td>
                  <td>{{ item.createdAt | date: 'dd/MM/yyyy' }}</td>
                  <td>
                    <div class="action-buttons">
                      @if (roleGroupUpdate) {
                        <button
                          class="primary-button view-button"
                          type="button"
                          (click)="prePopulation(item._id)"
                        >
                          <mat-icon class="btn-icon">visibility</mat-icon>
                        </button>
                      }
                      @if (roleGroupDelete) {
                        <button
                          class="primary-button delete-button"
                          type="button"
                          (click)="deleteRoleGroup(item._id)"
                        >
                          <mat-icon class="btn-icon">delete</mat-icon>
                        </button>
                      }
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
          @if (listOfRole.length === 0) {
            <tbody>
              <tr>
                <td colspan="7">
                  <img
                    class="no-data-img"
                    src="../../assets/dataNotFound.jpg"
                    alt="No Data Found"
                  />
                </td>
              </tr>
            </tbody>
          }
        </table>
      </div>

      <!-- Separator between Body and Footer -->
      <div class="component-separator"></div>

      <!-- Component Footer Section (Optional) -->
      <div class="component-footer">
        @if (totalLength !== 0) {
          <app-common-component-pagination
            [totalItems]="totalLength"
            [pageSize]="size"
            [currentPage]="page"
            [totalPages]="totalLength"
            (pageChange)="onPageChange($event)"
            (sizeChange)="onSizeChange($event)"
          >
          </app-common-component-pagination>
        }
      </div>
    </div>
  </div>
}
@if (addNewRoleGroup) {
  <div class="main-container">
    <!-- Header Section -->
    <div class="page-header">
      <div class="routing-buttons">
        <div
          class="action-button back-button"
          (click)="cancelFunc()"
          tabindex="0"
          (keydown.enter)="cancelFunc()"
        >
          <mat-icon class="icon back-icon">arrow_back</mat-icon>
        </div>
        <div
          class="action-button reload-button"
          (click)="prePopulation(selectedRoleId)"
          tabindex="0"
          (keydown.enter)="prePopulation(selectedRoleId)"
        >
          <mat-icon class="icon reload-icon">refresh</mat-icon>
        </div>
        <span class="page-title">Group Management</span>
      </div>
    </div>

    <div class="component-container">
      <!-- Form Section -->
      <form [formGroup]="addRoleGroupForm" novalidate>
        <div class="component-header">
          <h6 class="component-title">
            {{ editRoleGroup ? 'Update' : 'Add' }} Group
          </h6>
        </div>

        <!-- Separator between Header and Body -->
        <div class="component-separator"></div>

        <!-- Component Body Section -->
        <div class="component-body">
          <div class="form-section">
            <div class="form-group">
              <label for="groupName" class="form-label">Group Name</label>
              <mat-form-field appearance="outline">
                <mat-label>Group Name</mat-label>
                <input
                  matInput
                  id="groupName"
                  type="text"
                  placeholder="Group Name"
                  formControlName="groupName"
                  required
                />
                @if (
                  addRoleGroupForm.controls['groupName'].touched &&
                  addRoleGroupForm.controls['groupName'].errors
                    ?.requiredAndNoEmptySpaces
                ) {
                  <mat-error>
                    {{
                      addRoleGroupForm.controls['groupName'].errors
                        ?.requiredAndNoEmptySpaces
                    }}
                  </mat-error>
                }
                @if (
                  addRoleGroupForm.controls['groupName'].touched &&
                  addRoleGroupForm.controls['groupName'].errors
                    ?.nonNumericNoSpecialChars
                ) {
                  <mat-error>
                    {{
                      addRoleGroupForm.controls['groupName'].errors
                        ?.nonNumericNoSpecialChars
                    }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
        </div>

        <!-- Separator between Body and Footer -->
        <div class="component-separator"></div>

        <!-- Component Footer Section (Optional) -->
        <div class="component-footer">
          <div class="button-group">
            @if (roleGroupCreate && roleGroupUpdate) {
              <button
                type="button"
                (click)="save()"
                [ngClass]="editRoleGroup ? 'edit-button' : 'submit-button'"
              >
                {{ editRoleGroup ? 'Update ' : 'Save ' }}
                Group
                <mat-icon class="btn-icon">{{
                  editRoleGroup ? 'edit' : 'check_circle'
                }}</mat-icon>
              </button>
            }
          </div>
        </div>
      </form>
    </div>
  </div>
}
